import { stripIndent } from 'common-tags';
import { addDays, set } from 'date-fns';
import { ClubMembershipStarted } from './components/ClubMembershipStarted';
export const clubMembershipStartedEmailTemplate = {
  label: 'Club membership started',
  description: 'When customer buy your club membership trigger product',
  icon: 'ExchangeDollarLine',
  component: ClubMembershipStarted,
  defaultTemplate: {
    name: 'Club membership started',
    subject: {
      en: 'Welcome to our exclusive club',
      fr: 'Bienvenue dans notre club exclusif',
      it: 'Benvenuto nel nostro club esclusivo',
      es: '¡Bienvenido a nuestro club exclusivo',
      de: 'Willkommen in unserem exklusiven Club',
    },
    templateVariables: {
      club_membership_started: {
        body: {
          en: stripIndent`
            <p>Welcome to our exclusive club!</p>
          `,
          fr: stripIndent`
            <p>Bienvenue dans notre club exclusif !</p>
          `,
          it: stripIndent`
            <p>Benvenuto nel nostro club esclusivo!</p>
          `,
          es: stripIndent`
            <p>¡Bienvenido a nuestro club exclusivo!,</p>
          `,
          de: stripIndent`
            <p>Willkommen in unserem exklusiven Club</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'subscriptionAmount', label: 'Subscription Amount', example: '$19.99' },
    { key: 'subscriptionName', label: 'Subscription Name', example: 'VIP Club' },
    { key: 'nextBillingDate', label: 'Billing Date', example: 'June 30, 2025' },
    { key: 'customerPortalLink', label: 'Customer Portal Link', example: 'https://...' },
  ],
  utmParameters: {
    utmSource: 'club_membership_started',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
      currency: 'USD',
    },
    subscription: {
      currency: 'USD',
      product: { name: 'VIP Club' },
      price: { currencyOptions: { USD: { amount: 999 } } },
      nextBillingDate: set(addDays(new Date(), 3), { hours: 12, minutes: 0, seconds: 0, milliseconds: 0 }),
    },
    cmsRoutes: [
      { type: 'club', path: '/club', customDomain: null, cmsSubdomain: 'store_preview', active: true },
    ],
  }),

  defaultMessages: {
    promotion_title: 'Your Special Offer',
    promotion_subtitle: 'Use this code for your next purchase',
    cta_button: 'Shop Now',
    footer_text: '© 2024 All rights reserved',
  },
};
